import { memo, Suspense } from 'react';
import { lazyRetry } from '@utils/lazyRetry';

const QuickPanel = lazyRetry(() => import('@/components/theme-layouts/components/quickPanel/QuickPanel'));

/**
 * The right side layout 3.
 */
function RightSideLayout3() {
  return (
    <Suspense>
      <QuickPanel />
    </Suspense>
  );
}

export default memo(RightSideLayout3);
